import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { Route } from 'vue-router';

import config, { content } from '../../config';
import { setCanonical, setTitle, setDescription } from '../../seo';

import WithRender from './footer.tpl.html';

@WithRender
@Component({})
class Footer extends Vue {

    selectedTab: number = 0;
    seoTabs: any = [];
    content = content;

    get isVisible(){
        return this.$route.name === 'Performers';
    }

    get hasPartners(){
        return (config.Site == 'bel9850') ? true : false;
    }    

    mounted(){
        this.getTabs();
    }

    tabSelect(tab: number){
        this.selectedTab = tab;
    }

    getTabs(){
        const slug = this.$route.params.slug ? this.$route.params.slug : 'home'; 
        const seotext = content.categories ? content.categories : [];
        const selection = seotext.find((node: any)  => node.slug == slug);

        // Set title & desc
        setTitle(selection.title);
        setDescription(selection.desc);

        // Set tabs
        this.seoTabs = selection.tabs;
    }
    
    @Watch('$route')
    onRouteChange(to: Route, from: Route){
        this.getTabs();
    }

}

export default Footer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/layout/footer.ts